// domain / caso de uso

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// typings
import {
  IAtualizarVendaCreditoPayload,
  IVendaCreditoResponse,
} from "@/hooks/vendas-creditos/atualizar-uma-venda/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleAtualizarVendaCredito } from "@/domain/use-cases/vendas-creditos";

// toast helper
const notifySuccess = (message: string) =>
  toast(message, {
    type: "success",
    position: "top-center",
  });

const notifyError = (message: string) =>
  toast(message, {
    type: "error",
    position: "top-center",
  });

// novo tipo de input
type IDataApi = {
  venda_credito_id: number;
  payload: IAtualizarVendaCreditoPayload;
};

export function useAtualizarVendaCredito() {
  const queryClient = useQueryClient();
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<
    IVendaCreditoResponse, // retorno
    Error, // erro
    IDataApi // entrada
  >({
    mutationFn: async ({ venda_credito_id, payload }: IDataApi) => {
      return await handleAtualizarVendaCredito(token!, venda_credito_id, payload);
    },
    onSuccess: async (data) => {
      if (!data.success) {
        notifyError("Houve um error em atualizar crédito do cliente!");
        return;
      }
      notifySuccess("Venda crédito atualizada com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["vendas-creditos"] });
    },
    onError: async () => {
      notifyError("Houve um error em atualizar crédito do cliente!");
    },
  });

  return {
    atualizarVendaCredito: mutation.mutate,
    atualizarVendaCreditoAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
